import HttpService from "../util/HttpService";
import ParamEncrypt from "../util/ParamEncrypt";

const CONTEXT_PATH = "/video/api/v2";
class JobApiService {
    getJobDetailByCallId = (callId: any) => {
        return HttpService.get(CONTEXT_PATH.concat('/job-detail-service/local/') + ParamEncrypt.encryptData(callId));
        // return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat('local/').concat( callId));
    }

    getJobDetailDtoByRemoteUserAccessToken = (remoteUserAccessToken: string) => {
        return HttpService.get(CONTEXT_PATH.concat('/job-detail-service/remote/') + ParamEncrypt.encryptData(remoteUserAccessToken));
        // return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat('remote/').concat( remoteUserAccessToken));
    }

    getJobDetailDtoByLocalUserAccessToken = (localUserAccessToken: string) => {
        return HttpService.get(CONTEXT_PATH.concat('/job-detail-service/local/by-username/') + ParamEncrypt.encryptData(localUserAccessToken));
        // return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat('local/').concat('by-username/').concat( localUserAccessToken));
    }

    updateRoomDetails = (roomSid: string, localParticipantSid: string, roomName: string) => {
        return HttpService.put(CONTEXT_PATH.concat('/job-detail-service/room-detail'), ParamEncrypt.encryptObject({
            roomName: roomName,
            roomSid: roomSid,
            localParticipantSid: localParticipantSid
        }));
        // return HttpService.put(CONTEXT_PATH.concat(SERVICE_PATH).concat('room-detail'), {
        //     roomName: roomName,
        //     roomSid: roomSid,
        //     localParticipantSid: localParticipantSid
        // });
    }

    updateLocalParticipantDetail = (participantSid: string, identity: string) => {
        return HttpService.put(CONTEXT_PATH.concat('/job-detail-service/local-participant-detail'), ParamEncrypt.encryptObject({
            participantSid: participantSid,
            identity: identity
        }));
    }

    updateRemoteParticipantDetail = (participantSid: string, identity: string) => {
        return HttpService.put(CONTEXT_PATH.concat('/job-detail-service/remote-participant-detail'), ParamEncrypt.encryptObject({
            participantSid: participantSid,
            identity: identity
        }));
        // return HttpService.put(CONTEXT_PATH.concat(SERVICE_PATH).concat('remote-participant-detail'), {
        //         participantSid: participantSid,
        //         identity: identity
        // });
    }

}

const jobApiService = new JobApiService();
export default jobApiService;